import { render, staticRenderFns } from "./Chat.vue?vue&type=template&id=512cb867&scoped=true"
import script from "./Chat.vue?vue&type=script&lang=js"
export * from "./Chat.vue?vue&type=script&lang=js"
import style1 from "./Chat.vue?vue&type=style&index=1&id=512cb867&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512cb867",
  null
  
)

export default component.exports